var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane-copy-3-icons/24x24/ico_clock",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3336,8.0000666 C13.3336,5.05449812 10.9456519,2.66673326 8.00026671,2.66673326 C5.05445654,2.66673326 2.66693338,5.05425643 2.66693338,8.0000666 C2.66693338,10.9454518 5.05469824,13.3333999 8.00026671,13.3333999 C10.9454102,13.3333999 13.3336,10.9452101 13.3336,8.0000666 Z M14.6669334,8.0000666 C14.6669334,11.6815898 11.6817899,14.6667333 8.00026671,14.6667333 C4.31829566,14.6667333 1.33360004,11.6818086 1.33360004,8.0000666 C1.33360004,4.31787677 4.31807688,1.33339993 8.00026671,1.33339993 C11.6820087,1.33339993 14.6669334,4.31809555 14.6669334,8.0000666 Z M10.4716711,9.52866197 L9.5288621,10.471471 L7.33360004,8.27620889 L7.33360004,4.0000666 L8.66693332,4.0000666 L8.66693332,7.72392415 L10.4716711,9.52866197 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.884a98a0581faa328dbc770dcf0b8cfd.svg";
export { ForwardRef as ReactComponent };